import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { attachmentsKeys } from '../../api/query-keys/attachments';

import { visitsApi } from '@/features/visits/api/lib/visits';
import { ApiError } from '@/types/interfaces/api-error';

export const useAddAttachment = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ visitId, file }: { visitId: string; file: File }) =>
      visitsApi.createAttachment(visitId, file),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: attachmentsKeys.lists(),
      });
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
